<div class="title-container">
  <h1>{{title}}</h1>
  <h4 class="account-info" *ngIf="patientInfo?.patientAccountId">Patient Account: #{{ patientInfo.patientAccountId }}
  </h4>
</div>

<div class="section">
  <ng-content></ng-content>
</div>